import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useState } from "react";
import { deleteAnaliseProgrGeralDevolutiva } from "../../../../../../service/Rag/lançamento";
import ModalDevolutivaProgramaSeplag2024 from "./ModalDevolutivaProgrSeplag2024";

const DevolutivaUnidadeProgramaSetorial2024 = ({
  setAtualizarData,
  ListaAnaliseProgramaDevolutiva,
  dadosItemPrograma,
  permissionUser,
  setVisibleModalDevolutiva,
  visibleModaldevolutiva,
  setActionModaDevolutiva,
  actionModalDevolutiva,
  _dataRowOrgaoCentral,
  data,
  infoUnidade,
  permissionUserDevolutiva,
}) => {
  const [dataRow, setDataRow] = useState([]);
  //console.log("ListaAnaliseProgramaDevolutiva_ididid",ListaAnaliseProgramaDevolutiva) 

  //console.log("Data",data.ListaAnalisePrograma.filter(item => item.conOrdemAnalisePrograma != null && item.tipoAnalisePrograma == 1))
    
  const actionTemplate = (node) => {
    let buttonEditar;
    let buttonVer;
    let buttonDelete;
    if (permissionUserDevolutiva.edit === true) {
      buttonEditar = (
        <Button
          className="p-button-warning button-margin-left p-button p-component p-button-icon-only"
          style={{ marginRight: ".5em" }}
          onClick={() => {
            editarDevolutiva(node);
          }}
        >
          <i className="pi pi-pencil"></i>
        </Button>
      );
      buttonDelete = (
        <Button
          className="p-button-danger button-margin-left p-button p-component p-button-icon-only"
          onClick={() => {
            confirm(node);
          }}
        >
          <i className="pi pi-trash"></i>
        </Button>
      );
    }
    if (permissionUserDevolutiva.view === true) {
      buttonVer = (
        <Button
          className="p-button-info p-button p-component p-button-icon-only"
          onClick={() => {
            vizualizarDevolutiva(node);
          }}
          style={{ marginRight: ".5em" }}
        >
          <i className="pi pi-search"></i>
        </Button>
      );
    }

    return (
      <div className="formgroup-inline">
        <div className="field-checkbox">
          {buttonEditar}
          {buttonVer}
          {buttonDelete}
        </div>
      </div>
    );
  };

  const respostaSetorialAcaoOptions = [
    { name: "Não acatado", code: 0 },
    { name: "Acatado", code: 1 },
    { name: "Parcialmente acatado", code: 2 },
  ];

  const analiseItemAcaoOptions = [
    { name: "Indicador da Ação", code: 0 },
    { name: "Meta física", code: 1 },
    { name: "Execução Orçamentária", code: 2 },
    { name: "Outros", code: 3 },
  ];

  const confirm = (_data) => {
    confirmDialog({
      message: "Deseja realmente excluir a devolutiva_alfa?",
      header: "Confirmação de exclusão",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteDevolutiva(_data),
      reject: () => {},
    });
  };

  const vizualizarDevolutiva = (_data) => {
    setDataRow(_data);
    setVisibleModalDevolutiva(true);
    setActionModaDevolutiva({
      edit: false,
      disabled: true,
      create: false,
    });
  };
  
  const editarDevolutiva = (_data) => {
    setDataRow(_data);
    setVisibleModalDevolutiva(true);
    setActionModaDevolutiva({
      edit: true,
      disabled: false,
      create: false,
    });
  };

  const deleteDevolutiva = async (_data) => {
    await deleteAnaliseProgrGeralDevolutiva(_data.idenAnalisePrograma).then((_res) => {      
      window.$toast.current.show({
        severity: "success",
        summary: "Devolutiva do Indicador",
        detail: "Deletado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
    });
  };

  const getItemSituacao = (code) => {
    const found = respostaSetorialAcaoOptions.find((item) => item.code == code);
    return found ? found.name : code;
  };

  const getProgramaConcatenado = (dadosItemRag) => {
    return `${dadosItemPrograma.dadosItemRag.codgPrograma} - ${dadosItemPrograma.dadosItemRag.descPrograma}`;
  }

  return (
    <>
    {/* {console.log("TESTE_DATAROWOrgaoCentral",_dataRowOrgaoCentral)} */}
      <Panel header="Devolutiva da equipe da Unidade Setorial">
        <DataTable
          emptyMessage="Nenhum registro encontrado"
          showGridlines
          value={ListaAnaliseProgramaDevolutiva}
          dataKey="idenAnaliseAcao"
          paginator 
          rows={5} 
          //rowsPerPageOptions={[5, 10, 25, 50]}
        >
          <Column 
            field="conOrdemAnalisePrograma" header="Ordem" 
          />
          <Column            
            header="Programa"            
            body={(rowData) => getProgramaConcatenado(dadosItemPrograma.dadosItemRag)}
          />
          <Column
            field="numrAnaliseRecomendacao"
            header="Situação"
            body={(rowData) => getItemSituacao(rowData.numrAnaliseRecomendacao)}
          />
          <Column field="descAnalisePrograma" header="Devolutiva" />
          <Column field="dataAnalisePrograma" header="Data" />
          <Column field= "contaAcesso.pessoa.nomePessoa" header="Responsável Setorial" />
          <Column body={actionTemplate} header="Ações" />
        </DataTable>
      </Panel>
      {visibleModaldevolutiva && (
        <ModalDevolutivaProgramaSeplag2024
          visibleModaldevolutiva={visibleModaldevolutiva}
          setVisibleModalDevolutiva={setVisibleModalDevolutiva}
          actionModal={actionModalDevolutiva}
          setActionModal={setActionModaDevolutiva}
          dataRow={dataRow}
          setAtualizarData={setAtualizarData}
          dadosItemPrograma={dadosItemPrograma}
          _dataRowOrgaoCentral={_dataRowOrgaoCentral}
          infoUnidade={infoUnidade}
        />
      )}
    </>
  );
};
export default DevolutivaUnidadeProgramaSetorial2024;
